<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-line-chart mr-5"></i>Verkaufsstatistik</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="clear"></div>
    <div class="box-body" style="display: block;">
      <div class="row">
        <div class="col-xs-12">
          <ul class="list-group no-margin list-group-unbordered">
            <template v-for="(data, index) in orderedData">
                <li class="list-group-item" :key="index">
                  <div class="progress-group">
                    <span class="progress-text">{{data[0] | translate}}</span>
                    <div class="progress sm no-margin">
                      <div v-if="data[1].orders > 0" class="progress-bar" :class="[`progress-bar-${data[0]}`]" :style="`width:${Math.round(data[1].orders * 100 / orders.orders)}%`"></div>
                      <div v-else class="progress-bar progress-bar-warning" style="width:0%"></div>
                    </div>
                    <div class="row" :class="[`text-${data[0]}`]">
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">{{data[1].orders}} {{'orders' | translate}}</div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">{{data[1].items}} {{'items' | translate}}</div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">Ø VK: {{data[1].average | currency}}</div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small">{{'total' | translate}}: {{data[1].amount | currency}}</div>
                      </div>
                    </div>
                  </div>
                </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['orders'],
  data () {
    return {
      orderedData: null
    }
  },
  methods: {
    orderData () {
      let convertedChannels = Object.entries(this.orders.channels)
      let newArr = []

      for (const channel of convertedChannels) {
        if (channel[0] === 'schuhede' || channel[0] === 'selfservice_schuhede') {
          if (channel[0] === 'selfservice_schuhede' && newArr[0] === 'schuhede') {
            newArr.splice(1, 0, channel)
          } else {
            newArr.unshift(channel)
          }
        } else {
          newArr.push(channel)
        }
      }
      this.orderedData = Object.assign({}, newArr)
    }
  },
  mounted () {
    this.orderData()
  },
  watch: {
    orders () {
      this.orderData()
    }
  }
}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;
  }
  .progress-bar-schuhede {
    background-color: #EE379A;
  }
  .progress-bar-amazon {
    background-color: #f39c12;
  }
  .progress-bar-spartoo {
    background-color: #DB321B;
  }
  .progress-bar-zalando {
    background-color: #DB321B;
  }
  .progress-bar-ebay {
    background-color: #00c0ef;
  }
  .progress-bar-ats_de {
    background-color: #65B32E;
  }
  .text-schuhede {
    color: #EE379A;
  }
  .text-amazon {
    color: #f39c12;
  }
  .text-spartoo {
    color: #DB321B;
  }
  .text-zalando {
    color: #DB321B;
  }
  .text-ebay {
    color: #00c0ef;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/StatisticsReport.vue